<style lang="scss" scoped>

a {
    text-decoration: none ! important;
    cursor: default;
}
</style>

<template>
    <div class="row align-items-center">
        <div class="col-auto">
            <a href="#">
            <span class="avatar text-white bg-blue">
               <span class="badge" :class="[ isAlarm ? 'bg-red': ( isActive ? 'bg-blue' : 'bg-')]" ></span>
               <svg v-if="isWaterPointType('brunnen')" xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                  <path d="M2 20a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1" />
                  <path d="M2 16a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1" />
                  <path d="M15 12v-7.5a1.5 1.5 0 0 1 3 0" />
                  <path d="M9 12v-7.5a1.5 1.5 0 0 0 -3 0" />
                  <line x1="15" y1="5" x2="9" y2="5" />
                  <line x1="9" y1="10" x2="15" y2="10" />
               </svg>
               <svg v-if="isWaterPointType('ringleitung')" xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                  <circle cx="5" cy="5" r="2" />
                  <circle cx="19" cy="5" r="2" />
                  <circle cx="5" cy="19" r="2" />
                  <circle cx="19" cy="19" r="2" />
                  <line x1="5" y1="7" x2="5" y2="17" />
                  <line x1="7" y1="5" x2="17" y2="5" />
                  <line x1="7" y1="19" x2="17" y2="19" />
                  <line x1="19" y1="7" x2="19" y2="17" />
               </svg>
               <svg v-if="isWaterPointType('speicherbecken')" xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                  <path d="M3 7c3 -2 6 -2 9 0s6 2 9 0" />
                  <path d="M3 17c3 -2 6 -2 9 0s6 2 9 0" />
                  <path d="M3 12c3 -2 6 -2 9 0s6 2 9 0" />
                </svg>               
                <svg v-if="isWaterPointType('oeffentlich')" xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                    <rect x="4" y="4" width="16" height="16" rx="2" />
                    <circle cx="9" cy="12" r=".5" fill="currentColor" />
                    <circle cx="15" cy="12" r=".5" fill="currentColor" />
                </svg>
            </span>
            </a>
        </div>
        <div class="col">
            <a href="#" class="text-body d-block">
                <span v-if="isWithdrawalInfo">
                    {{ waterPoint.label }} ({{ waterPointTypeLabel }})
                </span>    
                <span v-else>
                    {{ waterPoint.label }} ({{ waterPointTypeLabel }})
                </span>
            </a>
            <a href="#">
                <small class="d-block text-muted text-truncate_">
                    <span v-if="isWithdrawalInfo">
                        Gestattung / Jahr {{ Math.round(maxWithdrawal).toLocaleString() }} m³, 
                        Entnahme {{ Math.round(totalWithdrawal).toLocaleString() }} m³ 
                        ({{ withdrawalRatio.toFixed(0) }}%)
                    </span>    
                    <span v-else>
                        {{ waterPointGeoLocation }}
                    </span>                     
                </small>
            </a>
            <a v-if="isWaterPointType('brunnen')" href="#">
                <small class="d-block text-muted text-truncate_">
                    <span v-if="waterPoint.lastStillWaterLevel" >
                        Grundwasserstand in Ruhe: Doku am {{ lastDateStillWaterLevel }} (vor {{ lastDaysStillWaterLevel }} / max. {{ stillWaterLevelFrequency }} Tage)
                    </span>    
                    <span v-else>
                        Bisher erfolgte keine Dokumentation des Grundwasserstands in Ruhe
                    </span>                     
                </small>
            </a>
        </div>
        <div v-show="isSelected(waterPoint) && false" class="col-auto">
            <a href="#" class="list-group-item-actions show"><!-- Download SVG icon from http://tabler-icons.io/i/star -->
            <svg xmlns="http://www.w3.org/2000/svg" class="icon text-azure" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z"></path></svg>
            </a>
        </div>
    </div>
</template>

<script>

// gemsamte Entnahme der wassernetnahmestelle pro Jahr / Entnahmemenge, gestattet / Anteil in Prozent an der  Entnahmemenge, gestattet
//import GeoPoint from "@/global/geopoint";

import * as dayjs from 'dayjs';

let component  = {
    name: 'WaterPointItem',
    inject: [
        'state',
        'config'
    ],
    props: {
    waterPoint: {
        type: Object,
        default: null
    },
    disabled: {
        type: Boolean,
        default: false
    },
    waterPointTypeList: {
        type: Array,
        default: function () { 
            return [
                {
                    label: 'Brunnen',
                    value: 'brunnen'
                },
                {
                    label: 'Ringleitung',
                    value: 'ringleitung'    
                },
                {
                    label: 'Speicherbecken',
                    value: 'speicherbecken'    
                },
                {
                    label: 'Öffentliche Wasserversorgung',
                    value: 'oeffentlich'    
                },
            ]
        }
    }
    },
    data: function () {
        return {
        
        }
    },
    computed: {
        totalWithdrawal: function () {
            return this.waterPoint.totalWithdrawal;
        },
        maxWithdrawal: function () {
            return this.waterPoint.maxWithdrawal;
        },
        withdrawalRatio: function () {
            if (this.maxWithdrawal) {
                return (this.totalWithdrawal / this.maxWithdrawal) * 100;
            }
            return null;
        },
        isWithdrawalInfo: function () {
            return !(this.withdrawalRatio === null);
        },
        waterPointGeoLocation: function () {
           //const geoPoint = new GeoPoint(waterPoint.longitude, waterPoint.latitude);
           //return '{} Nord {} OST'.format(geoPoint.getLatDeg(), geoPoint.getLonDeg());
            return '{} Nord / {} Ost'.format(
                this.floatToString(this.waterPoint.latitude),
                this.floatToString(this.waterPoint.longitude)
           )
        },
        isActive: function () { 
            return (this.totalWithdrawal && this.totalWithdrawal > 0 );    
        },
        isAlarm: function () { 
            const isOverMaxFrequency = ( 
                this.lastDaysStillWaterLevel > this.stillWaterLevelFrequency && 
                this.waterPoint.typ == 'brunnen'
            );
            return this.isOverMax || isOverMaxFrequency;
        },
        isOverMax: function () { 
            return (this.withdrawalRatio > 100);    
        },
        waterPointTypeLabel: function () {
            let self = this;
            return this.waterPointTypeList.reduce(function (accumulator, wp) {
                return accumulator + ( wp.value == self.waterPoint.typ ? wp.label : '');
            }, '');
        },
        stillWaterLevelFrequency: function () { 
            // Maximum period between two level measurements
            return this.config.logic.stillWaterLevelFrequency;    
        },
        lastDateStillWaterLevel: function () { 
            const yearNow = this.formatDateTime(dayjs(), 'YYYY');
            const yearLast = this.formatDateTime(this.waterPoint.lastStillWaterLevel, 'YYYY');
            let format = 'DD.MM';
        
            if (yearNow !== yearLast) {
                format = 'DD.MM.YYYY';
            }
            return this.formatDateTime(this.waterPoint.lastStillWaterLevel, format);
        },
        lastDaysStillWaterLevel: function () { 
            const now = dayjs();
            const last = this.waterPoint.lastStillWaterLevel;
            return now.diff(last , 'days');
        }
    },  
    methods: {
        getShortLabel: function (label) {
            return label.substring(0,2);
        },
        floatToString: function (loc) {
            return String(parseFloat(loc).toFixed(4)).replace('.',',');
        },
        isSelected: function (waterPoint) {
            return (waterPoint.id === this.state.waterPoint.id);
        },
        isWaterPointType: function ( typ) {
            return this.waterPoint.typ === typ ? true : false;
        },
        formatDateTime: function (date, format) {
            return dayjs(date).format(format);
        }
    }
}

let waterPointTypeList = component.props.waterPointTypeList.default();

export {
    component as default, 
    waterPointTypeList as waterPointTypeList 
}
</script>